/**
 * Created by hp on 2017/8/29.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios'
import {Cells} from 'react-weui';
import {Page} from '../components';
import {WKCell} from '../components/wk';
import '../css/page/BoardGeneralPage.css';
import logo from '../images/logo.png';
import config from '../config'


class BoardGeneralPage extends Component {
    constructor() {
        super();
        this.handleLoginOut = this.handleLoginOut.bind(this);
    }

    componentDidMount() {
        // init share
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: "十方教育",
                desc: "最好用的微课平台，首创PPT语音同步、视频语音交互，一分钟创建课程。与三千万伙伴一同享受成长的快乐。只有一种稳赚不赔的投资，就是学习",
                imgUrl: logo,
                link: window.location.href,
            }
        });
    }

    handleLoginOut() {
        localStorage.removeItem('_token');
        axios.get('/api/account/logout')
            .then(res => {
                if (res){
                    window.location.href = '/';
                }
            })
    }

    render() {
        return (
            <Page className="board-general-page">
                <div className="wk-inner-page">
                    <Cells>
                        {window.platform === 'pc' &&
                        <WKCell title="讲师管理后台" href={config.ADMIN_BASE_URL}/>
                        }
                        <WKCell title="修改手机号码" href="/account/edit/phone"/>
                        <WKCell title="使用教程" href="/question"/>
                        <WKCell title="联系我们" href="http://dwz.cn/3Er6Eu"/>
                        <WKCell title="退出登录" handleClick={this.handleLoginOut}/>
                    </Cells>

                    <div className="privacy-foot">
                        <a href="https://www.lizhiweike.com/secondary/privacy.html" title="荔枝微课隐私政策">荔枝微课隐私政策</a>
                    </div>
                </div>
            </Page>
        )
    }
}

export default connect((state) => ({}))(BoardGeneralPage);



// WEBPACK FOOTER //
// ./src/pages/BoardGeneralPage.js